import React from 'react';

const EmptyState = ({ title = 'Nothing here yet', subtitle = '', action }) => (
  <div className="flex flex-col items-center justify-center py-20 gap-6 text-center">
    <div className="w-20 h-20 rounded-full bg-zinc-900 border border-zinc-800 flex items-center justify-center text-3xl">🎵</div>
    <div className="space-y-2">
      <h3 className="text-xl font-black uppercase tracking-tighter text-white">{title}</h3>
      {subtitle && <p className="text-zinc-500 font-bold text-sm">{subtitle}</p>}
    </div>
    {action && (
      <button onClick={action.onClick} className="px-8 py-4 bg-white text-black font-black uppercase tracking-widest text-xs rounded-2xl">
        {action.label}
      </button>
    )}
  </div>
);

export default EmptyState;